/** @format */

// redux/slices/addressSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  GET_ADDRESSES: "/api/customer/get_customer_addresses",
  ADD_ADDRESSES: "/api/customer/add_customer_addresses",
  UPDATE_ADDRESS_BY_INDEX: `/api/customer/update-customer-address`,
  SET_DEFAULT_ADDRESS: `/api/customer/set_default_address`,
  //DELETE_ADDRESS_BY_INDEX : `/api/customer/delete-customer-address`
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

export const get_customer_addresses = createAsyncThunk(
  "address/get_customer_addresses",
  async (customerId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_ADDRESSES}/${customerId}`,
        { withCredentials: true },
      );
      //  console.log("Info utilisateur :", data);
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de l'inscription du client :", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const add_customer_addresses = createAsyncThunk(
  "address/add_customer_addresses",
  async ({ info, customerId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        `${API_ROUTES.ADD_ADDRESSES}/${customerId}`,
        { info },
        { withCredentials: true },
      );
      //console.log("Info utilisateur :", data);
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de l'inscription du client :", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const updateAddressByIndex = createAsyncThunk(
  "address/updateAddressByIndex",
  async (
    { customerId, index, updatedAddress },
    { rejectWithValue, fulfillWithValue },
  ) => {
    try {
      const { data } = await api.put(
        `${API_ROUTES.UPDATE_ADDRESS_BY_INDEX}/${customerId}`,
        { index, updatedAddress },
        { withCredentials: true },
      );
      //console.log("Info adrress :", data);
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de l'inscription du client :", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// addressSlice.js ou équivalent
export const setDefaultAddress = createAsyncThunk(
  "address/setDefaultAddress",
  async ({ customerId, index }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(
        `${API_ROUTES.SET_DEFAULT_ADDRESS}/${customerId}`,
        { index },
        { withCredentials: true },
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const deleteAddress = createAsyncThunk("address/delete", async (id) => {
  await axios.delete(`/addresses/${id}`);
  return id;
});

const addressReducer = createSlice({
  name: "address",
  initialState: {
    list: [],
    customerAddresses: [],
    addressMessage: "",
    addressError: "",
    addressLoading: false,
    error: null,
  },
  reducers: {
    messageClear: (state) => {
      state.addressError = "";
      state.addressMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(updateAddressByIndex.pending, (state) => {
        state.addressLoading = true;
        state.addressError = null;
      })
      .addCase(updateAddressByIndex.fulfilled, (state, action) => {
        const { index, updatedAddress } = action.payload;
        if (state.customerAddresses[index]) {
          state.customerAddresses[index] = updatedAddress;
        }
        state.addressLoading = false;
      })
      .addCase(updateAddressByIndex.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload || "Une erreur est survenue.";
      })

      .addCase(setDefaultAddress.fulfilled, (state, action) => {
        state.customerAddresses = action.payload.addresses; // mise à jour des adresses
        state.success = true;
      })
      .addCase(setDefaultAddress.pending, (state) => {
        state.addressLoading = true;
        state.addressError = null;
      })
      .addCase(setDefaultAddress.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload || "Une erreur est survenue.";
      })

      .addCase(add_customer_addresses.pending, (state) => {
        state.addressLoading = true;
        state.addressError = "";
      })
      .addCase(add_customer_addresses.fulfilled, (state, action) => {
        state.customerAddresses = action.payload.addresses;
        state.addressLoading = false;
        state.addressMessage = action.payload.message;
      })
      .addCase(add_customer_addresses.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload;
      })

      .addCase(get_customer_addresses.pending, (state) => {
        state.addressLoading = true;
        state.addressError = "";
      })
      .addCase(get_customer_addresses.fulfilled, (state, action) => {
        state.customerAddresses = action.payload.addresses;
        state.addressLoading = false;
        state.addressMessage = action.payload.message;
      })
      .addCase(get_customer_addresses.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload;
      });
  },
});

export const { messageClear } = addressReducer.actions;
export default addressReducer.reducer;
